import React from 'react'
import Button from '../buttons/buttons.component'
import EloIcon from '../custom-icons/elo-icon.component'
import VisaIcon from '../custom-icons/visa-icon.component'
import FontAwesome from 'react-fontawesome'
import AddCardModal from './add-card-modal.component'
import HipercardIcon from '../custom-icons/hipercard-icon.component'
import MasterCardIcon from '../custom-icons/master-card-icon.component'
import AmericanExpressIcon from '../custom-icons/amex-icon.component'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../actions/toast.actions'
import { CreditCardService } from '../../services/credit-card.service'
import { StyledCreditCards } from './styles/credit-cards.style'
import { bindActionCreators } from 'redux'
import { creditCardsActions } from '../../actions'
import { Creators as SiteCreators } from '../../ducks/site/site'

class CreditCardListComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			creditCards: [],
			isModalOpen: false
		}
	}

	componentWillMount() {
		this.props.getCards()
	}

	render() {
		const { isModalOpen } = this.state
		const { title, creditCards, getCards } = this.props

		return (
			<StyledCreditCards>
				<div>
					<p className="title">{title}</p>
					<div>{renderCreditCardsList.call(this)}</div>
					<div className="button-container">
						<Button
							secondary
							onClick={handleAddNewCreditCard.bind(this)}
							type={'button'}>
							{creditCards
								? creditCards.length > 0
									? 'Adicionar novo cartão'
									: 'Adicionar cartão'
								: 'Adicionar cartão'}
						</Button>
					</div>
				</div>
				<AddCardModal
					onClose={onModalClose.bind(this)}
					isOpen={isModalOpen}
					onSubmit={() => {
						getCards()
						this.setState({ isModalOpen: false })
					}}
				/>
			</StyledCreditCards>
		)
	}
}

function onModalClose(data) {
	if (data !== undefined) {
		const { errors } = data
		const { toastError, toastSuccess, hideLoading, getCards } = this.props
		if (errors != null && errors.length) toastError({ message: errors[0] })
		else {
			getCards()
			toastSuccess({ message: 'Cartão de crédito adicionado' })
		}

		hideLoading()
	}

	this.setState({ isModalOpen: false })
}

function handleAddNewCreditCard() {
	this.setState({
		isModalOpen: true
	})
}

function renderCreditCardsList() {
	const { creditCards } = this.props

	if (creditCards && creditCards.length > 0) {
		return creditCards.map((creditCard, index) => {
			return (
				<div className="credit-card-container" key={index}>
					<div className="icon-number-container">
						{mapCardBrandToIcon(creditCard.brand)}
						<span className="number">{`**** **** **** ${creditCard.lastFourDigits}`}</span>
					</div>
					<div className="icons-container">
						{handleIcons.call(this, creditCard)}
					</div>
				</div>
			)
		})
	}

	return (
		<div className="credit-card-container">
			<p className="no-credit-card-label">Nenhum cartão cadastrado</p>
		</div>
	)
}

function handleIcons(creditCard) {
	if (creditCard.main) {
		return <FontAwesome className="check" name="check" />
	} else {
		return (
			<span className="edit-icons">
				<FontAwesome
					name="exchange"
					className="trash-icon"
					onClick={setMainCreditCard.bind(this, creditCard.id)}
				/>
				<FontAwesome
					name="trash"
					onClick={inactivateCreditCard.bind(this, creditCard.id)}
				/>
			</span>
		)
	}
}

function inactivateCreditCard(creditCardId) {
	const { getCards } = this.props

	this.setState({ loading: true }, async () => {
		await CreditCardService.inactivateCreditCard(creditCardId)
		getCards()
	})
}

function setMainCreditCard(creditCardId) {
	const { getCards } = this.props

	this.setState({ loading: true }, async () => {
		await CreditCardService.setCrediCardAsMainCard(creditCardId)
		getCards()
	})
}

export function mapCardBrandToIcon(brand) {
	const brandToLowerCase = brand.toLowerCase()
	switch (brandToLowerCase) {
		case 'visa':
			return <VisaIcon className="card-icon" />
		case 'mastercard':
			return <MasterCardIcon className="card-icon" />
		case 'elo':
			return <EloIcon className="card-icon" />
		case 'americanexpress':
			return <AmericanExpressIcon className="card-icon" />
		case 'hipercard':
			return <HipercardIcon className="card-icon" />
		default:
			return null
	}
}

const mapStateToProps = ({ user, creditCards }) => ({ ...user, ...creditCards })

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			getCards: creditCardsActions.getCards,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const CreditCardList = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(CreditCardListComponent)
)
export default CreditCardList
